export default __webpack_public_path__ + "static/media/java.83165dfb.svg";